import * as React from 'react';
import { useCallback, useEffect, useRef } from 'react';
import { useCustomerStore } from '../../../redux/customers';
import { useOrderStore } from '../../../redux/orders';
import { useToastStore } from '../../../redux/toast';
import { OrdersPage } from '../components';

export const OrdersPageContainer: React.FC = () => {
    const refresherRef = useRef<HTMLIonRefresherElement>(null);
    const toastStore = useToastStore();

    const { selectedId: customerId } = useCustomerStore();
    const { isFetching, ordersByActiveCustomer, fetchOrders, errorMessage, clearErrors } = useOrderStore();

    const fetch = useCallback(() => {
        if (!customerId) return;
        fetchOrders({ customerId }).catch(() => { /* handled via state and toast */ }).finally(() => {
            refresherRef.current?.complete();
        });
    }, [fetchOrders, customerId]);

    useEffect(() => {
        fetch();
    }, [customerId]);

    useEffect(() => {
        if (errorMessage) {
            toastStore.showError({ message: errorMessage }).then(() => clearErrors());
        }
    }, [errorMessage]);

    return (
        <OrdersPage
            orders={ordersByActiveCustomer}
            isFetching={isFetching}
            doRefresh={fetch}
            refresherRef={refresherRef}
        />
    );
};
